import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const BusinessSummaryContext = createContext();

export const useBusinessSummary = () => {
  const context = useContext(BusinessSummaryContext);
  if (!context) {
    throw new Error(
      "useBusinessSummary must be used within a BusinessSummaryProvider"
    );
  }
  return context;
};

export const BusinessSummaryProvider = ({ children }) => {
  const baseUrl  = process.env.REACT_APP_BASE_URL;
  const [businessSummary, setBusinessSummary] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  useEffect(() => {
    const fetchBusinessSummary = async () => {
      try {
        const params = {};
        if (dateFrom) params.dateFrom = dateFrom;
        if (dateTo) params.dateTo = dateTo;
        const response = await axios.get(
          `${baseUrl}/api/purchase-orders/business-summary-api`,
          { params }
        );
        setBusinessSummary(response.data || []);
        console.log("Business Summary API Response:", response.data);
        setError(null);
      } catch (err) {
        console.error("Error fetching business summary:", err);
        setError("Failed to fetch business summary.");
        setBusinessSummary([]);
      } finally {
        setLoading(false);
      }
    };

    fetchBusinessSummary();
  }, [dateFrom, dateTo]);

  return (
    <BusinessSummaryContext.Provider
      value={{
        businessSummary,
        loading,
        error,
        dateFrom,
        setDateFrom,
        dateTo,
        setDateTo,
      }}
    >
      {children}
    </BusinessSummaryContext.Provider>
  );
};